import type { FC } from "react";

import { iconPack, type TIconPack } from "@ch/assets/icons";
import type { SVGIconProps } from "./SVGIcon";

export interface IconProps {
  color?: SVGIconProps["color"];

  /**
   * The name of the icon from the icon pack.
   */
  name: TIconPack;

  /**
   * The size of the icon which will be used as the width and height
   */
  size?: number | string;
}

const Icon: FC<IconProps> = ({ name, size, ...props }) => {
  const IconFromPack = iconPack[name];

  if (!IconFromPack) return null;

  return <IconFromPack height={size} width={size} {...props} />;
};

export default Icon;
